export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const RESET_UI = "RESET_UI";
export const RESET_SUCCESS = 'RESET_SUCCESS';
export const CLEARSUCCESSRESET = 'CLEARSUCCESSRESET'